import React from 'react';

export default function DeleteModal({ isOpen, onClose, onConfirm, itemName }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Confirm Delete</h3>
                <p>Are you sure you want to delete {itemName}?</p>
                <div className="modal-actions">
                    <button 
                        className="cancel-button"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button 
                        className="delete-button"
                        onClick={onConfirm}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
} 